module.exports = __webpack_public_path__ + "static/media/chai-icon.e625470e.png";